module.exports = function getResource(label, vars = []) {
    let resources = {
        openUntil: `Open until ${vars[0]}`,
        closed: 'Closed',
        storeHoursUnavailable: 'Store hours not available'
    };
    return resources[label];
};
